import { h } from "preact";
import { useState } from "preact/hooks";
import QuantityInput from "../../global/quantity-input/quantity-input-react";

export default function MiniCartQuantity({ item, max }) {
  const [quantity, setQuantity] = useState(item.quantity);
  const [pendingRequests, setPendingRequests] = useState([]);

  if (pendingRequests.length === 0 && item.quantity !== quantity) {
    setQuantity(item.quantity);
  }

  const updateQuantity = (quantity) => {
    setQuantity(quantity);
    const requestId = window.crypto.randomUUID();
    setPendingRequests([...pendingRequests, requestId]);
    window.updateCart(
      { updates: { [item.id]: quantity } },
      {
        onAfterAdd: (data) => {
          const newItem = data.items.find(({ id }) => id === item.id);

          if (!newItem) return;

          if (newItem.quantity !== quantity) {
            setQuantity(newItem.quantity);
          }

          setPendingRequests(
            pendingRequests.filter((request) => request !== requestId),
          );
        },
      },
    );
  };

  return (
    <QuantityInput quantity={quantity} setQuantity={updateQuantity} max={max} />
  );
}
